import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { usePortalTarget } from '../../components/UIProvider/PortalTargetContext.js';

const Portal = _ref => {
  let {
    children,
    portalTarget
  } = _ref;
  const [container, setContainer] = useState();
  const globalPortalTarget = usePortalTarget();
  useEffect(() => {
    const element = document.createElement('div');
    const target = portalTarget || globalPortalTarget || document.body;
    target.appendChild(element);
    setContainer(element);
    return () => {
      target.removeChild(element);
    };
  }, [portalTarget, globalPortalTarget]);

  // only render children once parent has been appended to DOM
  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
};

export { Portal as default };
